import { fetchPageData } from "../utils/fetch";
export const getUserData = async (token) => {
  const endpoint = "user/data";
  const method = "GET";
  const err = "Failed to fetch user data.";
  const fetchedData = await fetchPageData(endpoint, method, err, token);
  return fetchedData;
};
